import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos.js";
import ExpandMoreIcon$1 from "@mui/icons-material/ExpandMore.js";
import { Typography, css, Button } from "@mui/material";
import MuiCard from "@mui/material/Card/index.js";
import MuiCardContent from "@mui/material/CardContent/index.js";
import { styled } from "@mui/material/styles";
const Card = styled(MuiCard, {
  shouldForwardProp: (prop) => !["includeWeekends"].includes(prop)
})`
  box-shadow: none;
  background: none;
  font-family: Lato, sans-serif;

  min-width: ${(props) => props.includeWeekends ? "533px" : "auto"};
  width: ${(props) => props.includeWeekends ? "auto" : "391px"};
  min-height: 504px;
  border-radius: 16px;
`;
const CardContent = styled(MuiCardContent)`
  padding-bottom: 0;
  padding-top: ${({ theme }) => theme.spacing(1)};
`;
const ClinicHeaderCardContent = styled(MuiCardContent)(
  ({ theme }) => `
    padding-bottom: ${theme.spacing(2)};
    padding-top: ${theme.spacing(2)};
    box-shadow: inset 0px -1px 0px ${theme.palette.grey[200]};
  `
);
const ClinicCurrentMonthHeader = styled("div")`
  display: flex;
  justify-content: center;
`;
const PatientHeader = styled("div")`
  display: flex;
  margin-bottom: 16px;
  justify-content: space-between;
`;
const PatientPeriod = styled(Typography)`
  ${({ theme }) => css({ ...theme.typography["Lato Emphasized 1"] })}
`;
const WorkingDaysContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "scroll"
})`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  ${({ scroll }) => scroll && css`
      max-height: 322px;
      overflow: auto;
    `}

  ${({ scroll, theme }) => scroll && theme.breakpoints.up("md") && css`
      max-height: 351px;
    `}
`;
const WorkingDaysHeader = styled("div", {
  shouldForwardProp: (prop) => prop !== "color"
})`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  position: sticky;
  top: 0;
  z-index: 1;

  ${({ color }) => color && css`
      background-color: ${color};
    `}
`;
const BackArrowIcon = styled(ArrowBackIosIcon)`
  width: 8px;
  color: transparent;
`;
const WorkingDays = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex: 0 0 100%;
  font-size: 15px;
`;
const WorkingSlotsContainer = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex: 0 0 100%;
`;
const WorkingDayContainer = styled("div")`
  flex-direction: column;
`;
const WorkingSlots = styled("div")`
  margin-top: 17px;
  text-align: center;
  display: flex;
  flex-direction: column;
`;
const LoadMoreContainer = styled("div")`
  display: flex;
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing(1)};
`;
const LoadMore = styled(Button)(
  ({ theme }) => `
    font-size: 14px;
    font-weight: 700;
    color: ${theme.palette.primary[800]}; // aqua maps to primary
    letter-spacing: 0.25px;
    line-height: 20px;
    display: flex;
    align-items: center;
  `
);
const ExpandMoreIcon = styled(ExpandMoreIcon$1)(({ theme }) => ({
  width: "30px",
  "&.MuiSvgIcon-root": {
    width: "24px",
    height: "24px"
  },
  color: theme.palette.primary[800]
  // Changed from aqua to primary
}));
const DatesWrap = styled(CardContent)`
  padding-right: 0;
  padding-left: 0;

  ${({ theme }) => theme.breakpoints.up("md") && css`
      padding-top: 0px;
    `}
  &:last-child {
    padding-bottom: ${({ theme }) => theme.spacing(1)};

    ${({ theme }) => theme.breakpoints.up("md") && css`
        padding-bottom: ${theme.spacing(2)};
      `}
  }
`;
export {
  BackArrowIcon,
  Card,
  CardContent,
  ClinicCurrentMonthHeader,
  ClinicHeaderCardContent,
  DatesWrap,
  ExpandMoreIcon,
  LoadMore,
  LoadMoreContainer,
  PatientHeader,
  PatientPeriod,
  WorkingDayContainer,
  WorkingDays,
  WorkingDaysContainer,
  WorkingDaysHeader,
  WorkingSlots,
  WorkingSlotsContainer
};
